import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectIsAuthenticated } from 'redux/user/user.selectors';
import Preload from './preload/preload.component';
import RefreshTokenValidationGate from './refresh-token-validation-gate.component';

const AuthenticationGate = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const location = useLocation();

  return (
    <RefreshTokenValidationGate>
      {isAuthenticated ? (
        <Preload>
          <Outlet />
        </Preload>
      ) : (
        <Navigate to="/login" state={{ from: location }} replace />
      )}
    </RefreshTokenValidationGate>
  );
};

export default AuthenticationGate;
